import { cn } from '@commenda/utils';
import React from 'react';
import { DateSegmentInputProps } from '../types';
import { SEGMENT_CONFIG } from '../constants';

export function DateSegmentInput({
  segment,
  value,
  onChange,
  onKeyDown,
  onFocus,
  onBlur,
  disabled = false,
  inputRef,
  placeholder,
  ariaLabel,
  maxLength,
  isFocused,
}: DateSegmentInputProps) {
  const config = SEGMENT_CONFIG[segment];

  const baseInputClass = cn(
    'text-center bg-transparent border-0 outline-none w-full min-w-0 overflow-hidden',
    'txt-small-regular txt-medium-regular text-text-primary placeholder:text-text-placeholder',
    'focus:outline-none focus:ring-0 focus:border-0 focus-visible:outline-none focus-visible:ring-0',
    'appearance-none px-0',
    '[&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none',
    '[&::-ms-clear]:hidden',
    disabled && 'cursor-not-allowed text-text-disabled'
  );

  const segmentContainerClass = cn(
    'flex items-center justify-center h-full overflow-hidden',
    config.widthClass,
    isFocused && !disabled
      ? 'bg-bg-brand-hover rounded transition-colors px-0 py-0.5'
      : 'px-0',
    disabled && 'opacity-50'
  );

  return (
    <div className={segmentContainerClass}>
      <input
        ref={inputRef}
        type="text"
        inputMode="numeric"
        pattern="[0-9]*"
        maxLength={maxLength}
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        onFocus={onFocus}
        onBlur={onBlur}
        disabled={disabled}
        placeholder={placeholder}
        className={baseInputClass}
        aria-label={ariaLabel}
      />
    </div>
  );
}

